module.exports = require('./src')


//////////////////
// WEBPACK FOOTER
// ../~/region/index.js
// module id = 195
// module chunks = 2